module.exports = __webpack_public_path__ + "img/news-banner-eng.e408e823.png";